import { render, staticRenderFns } from "./Cancion.vue?vue&type=template&id=7ba076b4&scoped=true"
import script from "./Cancion.vue?vue&type=script&lang=js"
export * from "./Cancion.vue?vue&type=script&lang=js"
import style0 from "./Cancion.vue?vue&type=style&index=0&id=7ba076b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba076b4",
  null
  
)

export default component.exports